import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    id: 1,
    tag: "全剧热播中",
    title: "年轻的母亲",
    subtitle: "一个女孩成为母亲的那一年，命运递来了一份来不及准备的礼物。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20scene%20of%20a%20young%20chinese%20mother%20gently%20holding%20her%20baby%20by%20a%20large%20sunlit%20window%2C%20warm%20golden%20afternoon%20light%20and%20soft%20shadows%2C%20rich%20deep%20warm%20color%20grading%2C%20gentle%20film%20grain%2C%20emotional%20tender%20atmosphere%2C%20premium%20editorial%20photography&width=1920&height=1080&seq=young-mother-hero01&orientation=landscape",
    primaryTo: "/category",
    primaryLabel: "立即观看",
  },
  {
    id: 2,
    tag: "第 24 集 · 大结局",
    title: "家在哪里",
    subtitle: "所有的坚持与和解，都在天亮之前给出了答案。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20scene%20of%20a%20young%20woman%20looking%20out%20of%20a%20warm%20lit%20apartment%20window%20at%20dusk%20city%20glow%2C%20amber%20and%20orange%20tones%2C%20gentle%20film%20grain%2C%20soft%20bokeh%20lights%2C%20melancholic%20yet%20hopeful%20mood%2C%20premium%20editorial%20photography&width=1920&height=1080&seq=young-mother-hero02&orientation=landscape",
    primaryTo: "/episode/24",
    primaryLabel: "观看大结局",
  },
  {
    id: 3,
    tag: "剧情深度解读",
    title: "看懂每一次转身",
    subtitle: "角色解析、意象解读与时间线梳理，带你读懂这部剧的暗线。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20scene%20of%20a%20warm%20family%20dinner%20table%20with%20golden%20lantern%20light%20and%20soft%20shadows%2C%20intimate%20cozy%20interior%2C%20deep%20warm%20orange%20color%20grading%2C%20gentle%20film%20grain%2C%20nostalgic%20emotional%20atmosphere%2C%20premium%20editorial%20photography&width=1920&height=1080&seq=young-mother-hero03&orientation=landscape",
    primaryTo: "/plot",
    primaryLabel: "阅读剧情介绍",
  },
  {
    id: 4,
    tag: "全集在线入口",
    title: "1 - 24 集 全集畅看",
    subtitle: "分集剧情、封面与首播时间一览，快速定位你想看的那一集。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20scene%20of%20a%20serene%20rooftop%20at%20sunset%20with%20warm%20orange%20sky%20and%20city%20skyline%2C%20soft%20clouds%20and%20bokeh%20lights%2C%20gentle%20film%20grain%2C%20rich%20warm%20color%20grading%2C%20dreamy%20hopeful%20mood%2C%20premium%20editorial%20photography&width=1920&height=1080&seq=young-mother-hero04&orientation=landscape",
    primaryTo: "/category",
    primaryLabel: "查看全部剧集",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const go = useCallback((next: number) => {
    setIndex((next + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const active = slides[index];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden bg-primary-950">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`年轻的母亲 剧照 ${slide.title}`}
            title={`年轻的母亲 ${slide.title}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/25" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/30" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full flex items-center">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl">
            <span
              key={`tag-${active.id}`}
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-accent-950 text-xs font-medium font-label animate-fade-in"
            >
              <i className="ri-fire-fill"></i>
              {active.tag}
            </span>
            <h1
              key={`title-${active.id}`}
              className="mt-5 font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight animate-fade-up"
            >
              {active.title}
            </h1>
            <p
              key={`sub-${active.id}`}
              className="mt-4 text-base md:text-lg text-background-200 leading-relaxed max-w-xl animate-fade-up"
            >
              {active.subtitle}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to={active.primaryTo}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-play-fill text-lg"></i>
                {active.primaryLabel}
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 hover:bg-background-50/25 text-background-50 text-sm font-medium whitespace-nowrap backdrop-blur-sm transition-colors cursor-pointer"
              >
                <i className="ri-search-line"></i>
                搜索剧集
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute z-20 bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-3">
        <button
          type="button"
          onClick={() => go(index - 1)}
          className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 backdrop-blur-sm transition-colors cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <div className="flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-8 bg-accent-500" : "w-2 bg-background-50/50 hover:bg-background-50/80"
              }`}
              aria-label={`切换到第${i + 1}张`}
            />
          ))}
        </div>
        <button
          type="button"
          onClick={() => go(index + 1)}
          className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 backdrop-blur-sm transition-colors cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}